// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const PERSONA_DESTINATIONS = {
    // ── Overview and executive ──
    dashboard: {
        route: '/admin',
        module: null,
        label: { en: 'Dashboard', vi: 'Tổng quan' },
    },
    board_report: {
        route: '/admin/governance/board-report',
        module: 'governance',
        label: { en: 'Board Report', vi: 'Báo cáo Ban Giám đốc' },
    },
    compliance_score: {
        route: '/admin/governance/scores',
        module: 'governance',
        label: { en: 'Compliance Score', vi: 'Điểm tuân thủ' },
    },
    executive_summaries: {
        route: '/admin/program-governance/summaries',
        module: 'program_governance',
        label: { en: 'Executive Summaries', vi: 'Tóm tắt điều hành' },
    },
    compliance_work_programme: {
        route: '/admin/compliance-operations',
        module: 'governance',
        label: { en: 'Compliance Work Programme', vi: 'Chương trình công việc tuân thủ' },
    },
    penalty_readiness: {
        route: '/admin/penalty-exposure',
        module: 'localization',
        label: { en: 'Penalty Readiness', vi: 'Mức độ sẵn sàng trước chế tài' },
        location: {
            en: 'Regulatory › Penalties & Enforcement',
            vi: 'Quy định › Chế tài và cưỡng chế',
        },
    },
    // ── Data protection ──
    rights_requests: {
        route: '/admin/rights-requests',
        module: 'rights_requests',
        label: { en: 'Rights Requests', vi: 'Yêu cầu quyền' },
    },
    dpias: {
        route: '/admin/assessments/dpias',
        module: 'assessments',
        label: { en: 'DPIAs', vi: 'Đánh giá tác động xử lý dữ liệu cá nhân' },
    },
    dossier_filings: {
        route: '/admin/assessments/dossier-filings',
        module: 'assessments',
        label: { en: 'Dossier Filings', vi: 'Hồ sơ nộp' },
    },
    transfer_assessments: {
        route: '/admin/assessments/transfers',
        module: 'assessments',
        label: { en: 'Transfer Assessments', vi: 'Đánh giá chuyển dữ liệu' },
    },
    dpo_appointments: {
        route: '/admin/privacy-office/appointments',
        module: 'assessments',
        label: { en: 'DPO appointments', vi: 'Quyết định cử nhân sự bảo vệ dữ liệu cá nhân' },
    },
    handbook_assessments: {
        route: '/admin/program-governance/handbook-assessments',
        module: 'program_governance',
        label: { en: 'Handbook Assessments', vi: 'Đánh giá theo cẩm nang' },
    },
    processing_activities: {
        route: '/admin/data-mapping/activities',
        module: 'data_mapping',
        label: { en: 'Processing Activities', vi: 'Hoạt động xử lý' },
    },
    data_flows: {
        route: '/admin/data-mapping/flows',
        module: 'data_mapping',
        label: { en: 'Data Flows', vi: 'Luồng dữ liệu' },
    },
    data_registry: {
        route: '/admin/data-mapping/registry',
        module: 'data_mapping',
        label: { en: 'Data Registry', vi: 'Đăng ký Dữ liệu' },
    },
    retention_policies: {
        route: '/admin/organizations/retention-policies',
        module: 'organizations',
        label: { en: 'Retention Policies', vi: 'Chính sách lưu giữ' },
    },
    breach_notifications: {
        route: '/admin/incidents/breach-notifications',
        module: 'incidents',
        label: { en: 'Breach Notifications', vi: 'Thông báo Vi phạm' },
    },
    privacy_monitoring: {
        route: '/admin/privacy-scanner/monitoring',
        module: 'privacy_scanner',
        label: { en: 'Privacy Monitoring', vi: 'Giám sát quyền riêng tư' },
    },
    // ── Consent and marketing communications ──
    consent_workflows: {
        route: '/admin/consent/workflows',
        module: 'consent',
        label: { en: 'Workflows', vi: 'Luồng công việc' },
    },
    consent_evidence: {
        route: '/admin/consent/evidence',
        module: 'consent',
        label: { en: 'Consent Evidence', vi: 'Tài liệu chứng minh sự đồng ý' },
    },
    cmp_integration: {
        route: '/admin/consent/cmp-integration',
        module: 'consent',
        label: { en: 'CMP Integration', vi: 'Tích hợp CMP' },
    },
    consent_properties: {
        route: '/admin/consent-properties/properties',
        module: 'consent_properties',
        label: { en: 'Properties', vi: 'Thuộc tính' },
    },
    marketing_consent: {
        route: '/admin/marketing-communications/consents',
        module: 'consent',
        label: { en: 'Marketing Consent', vi: 'Sự đồng ý nhận quảng cáo' },
    },
    suppression_register: {
        route: '/admin/marketing-communications/suppressions',
        module: 'consent',
        label: { en: 'Suppression Register', vi: 'Sổ đăng ký chặn gửi' },
    },
    // ── Data and AI governance ──
    classification_taxonomies: {
        route: '/admin/classification/taxonomies',
        module: 'classification',
        label: { en: 'Taxonomies', vi: 'Phân loại' },
    },
    enterprise_data_map: {
        route: '/admin/classification/enterprise-map',
        module: 'classification',
        label: { en: 'Enterprise Data Map', vi: 'Bản đồ dữ liệu doanh nghiệp' },
    },
    attestation_cycles: {
        route: '/admin/data-mapping/attestation',
        module: 'data_mapping',
        label: { en: 'Attestation Cycles', vi: 'Chu kỳ chứng thực' },
    },
    data_service_providers: {
        route: '/admin/data-service-providers',
        module: 'localization',
        label: { en: 'Data-Service Provider Records', vi: 'Hồ sơ nhà cung cấp dịch vụ dữ liệu' },
        location: { en: 'Regulatory › Regulatory Registers', vi: 'Quy định › Sổ đăng ký pháp lý' },
    },
    dataset_catalog: {
        route: '/admin/public-data/datasets',
        module: 'sector_overlays',
        label: { en: 'Dataset Catalog', vi: 'Danh mục tập dữ liệu' },
        location: {
            en: 'Sector Overlays › Public Administration',
            vi: 'Lớp phủ ngành › Hành chính công',
        },
    },
    data_sharing_register: {
        route: '/admin/public-data/sharing',
        module: 'sector_overlays',
        label: { en: 'Sharing Register', vi: 'Sổ đăng ký chia sẻ' },
        location: {
            en: 'Sector Overlays › Public Administration',
            vi: 'Lớp phủ ngành › Hành chính công',
        },
    },
    open_data_releases: {
        route: '/admin/public-data/releases',
        module: 'sector_overlays',
        label: { en: 'Open Data Releases', vi: 'Công bố dữ liệu mở' },
        location: {
            en: 'Sector Overlays › Public Administration',
            vi: 'Lớp phủ ngành › Hành chính công',
        },
    },
    ai_system_register: {
        route: '/admin/ai-governance',
        module: 'assessments',
        label: { en: 'AI System Register', vi: 'Sổ đăng ký hệ thống AI' },
    },
    change_review: {
        route: '/admin/monitoring/change-review',
        module: 'monitoring',
        label: { en: 'Change Review', vi: 'Xem xét thay đổi' },
    },
    framework_evidence_packs: {
        route: '/admin/framework-evidence-packs',
        module: 'assessments',
        label: { en: 'Framework evidence packs', vi: 'Gói bằng chứng theo khung tuân thủ' },
    },
    // ── Vendors and contracts ──
    vendors: {
        route: '/admin/governance/vendors',
        module: 'governance',
        label: { en: 'Vendors', vi: 'Nhà cung cấp' },
    },
    cross_border: {
        route: '/admin/governance/cross-border',
        module: 'governance',
        label: { en: 'Cross-Border', vi: 'Xuyên biên giới' },
    },
    vendor_risk_portfolio: {
        route: '/admin/vendor-risk/portfolio',
        module: 'vendor_risk',
        label: { en: 'Risk Portfolio', vi: 'Danh mục rủi ro' },
    },
    sub_processor_register: {
        route: '/admin/vendor-risk/sub-processor-register',
        module: 'vendor_risk',
        label: { en: 'Sub-Processor Register', vi: 'Sổ đăng ký Bên xử lý phụ' },
    },
    contracts: {
        route: '/admin/contracts',
        module: 'vendor_risk',
        label: { en: 'Contracts', vi: 'Hợp đồng' },
    },
    // ── Incidents and authorities ──
    incidents: {
        route: '/admin/incidents',
        module: 'incidents',
        label: { en: 'All Incidents', vi: 'Tất cả sự cố' },
    },
    regulatory_sla: {
        route: '/admin/incident-ops/regulatory-sla',
        module: 'incident_ops',
        label: { en: 'Regulatory SLA', vi: 'SLA Quy định' },
    },
    post_incident_review: {
        route: '/admin/incident-ops/post-review',
        module: 'incident_ops',
        label: { en: 'Post-Incident Review', vi: 'Đánh giá Hậu sự cố' },
    },
    regulator_exports: {
        route: '/admin/incident-ops/regulator-exports',
        module: 'incident_ops',
        label: { en: 'Regulator Exports', vi: 'Xuất Cơ quan' },
    },
    incident_authority_requests: {
        route: '/admin/incidents/authority-requests',
        module: 'incidents',
        label: { en: 'Authority Requests', vi: 'Yêu cầu Cơ quan' },
    },
    disclosure_register: {
        route: '/admin/incidents/disclosure-register',
        module: 'incidents',
        label: { en: 'Disclosure Register', vi: 'Sổ Công khai' },
    },
    authority_directions: {
        route: '/admin/authority-directions',
        module: 'localization',
        label: { en: 'Authority Directions', vi: 'Yêu cầu của cơ quan có thẩm quyền' },
        location: { en: 'Regulatory › Regulatory Registers', vi: 'Quy định › Sổ đăng ký pháp lý' },
    },
    authority_readiness: {
        route: '/admin/monitoring/authority-readiness',
        module: 'monitoring',
        label: { en: 'Authority Readiness', vi: 'Sẵn sàng cơ quan' },
    },
    regulator_inquiries: {
        route: '/admin/monitoring/ric',
        module: 'monitoring',
        label: { en: 'Regulator Inquiries', vi: 'Yêu cầu cơ quan' },
    },
    continuity_exercises: {
        route: '/admin/continuity/exercises',
        module: 'assessments',
        label: { en: 'Continuity Exercises', vi: 'Diễn tập liên tục' },
    },
    // ── Audit and assurance ──
    audit_engagements: {
        route: '/admin/program-governance/audit-engagements',
        module: 'program_governance',
        label: { en: 'Audit Engagements', vi: 'Cuộc kiểm toán' },
    },
    audit_readiness: {
        route: '/admin/program-governance/readiness',
        module: 'program_governance',
        label: { en: 'Audit Readiness', vi: 'Sẵn sàng kiểm toán' },
    },
    evidence_gaps: {
        route: '/admin/program-governance/evidence-gaps',
        module: 'program_governance',
        label: { en: 'Evidence Gaps', vi: 'Khoảng trống bằng chứng' },
    },
    remediation_plans: {
        route: '/admin/program-governance/remediation-plans',
        module: 'program_governance',
        label: { en: 'Remediation Plans', vi: 'Kế hoạch Khắc phục' },
    },
    obligation_mappings: {
        route: '/admin/program-governance/obligation-mappings',
        module: 'program_governance',
        label: { en: 'Obligation Mappings', vi: 'Ánh xạ Nghĩa vụ' },
    },
    governance_documents: {
        route: '/admin/program-governance/governance-documents',
        module: 'program_governance',
        label: { en: 'Governance Documents', vi: 'Tài liệu Quản trị' },
    },
    audit_evidence_packs: {
        route: '/admin/audit/evidence-packs',
        module: 'audit_trail',
        label: { en: 'Audit evidence packs', vi: 'Gói bằng chứng kiểm toán' },
    },
    governance_approvals: {
        route: '/admin/governance/approvals',
        module: 'governance',
        label: { en: 'Approvals', vi: 'Phê duyệt' },
    },
    enforcement_register: {
        route: '/admin/penalty-exposure/register',
        module: 'localization',
        label: { en: 'Enforcement Register', vi: 'Sổ theo dõi chế tài' },
        location: {
            en: 'Regulatory › Penalties & Enforcement',
            vi: 'Quy định › Chế tài và cưỡng chế',
        },
    },
    monitoring_programs: {
        route: '/admin/monitoring/programs',
        module: 'monitoring',
        label: { en: 'Programs', vi: 'Chương trình' },
    },
    raci_matrix: {
        route: '/admin/monitoring/raci',
        module: 'monitoring',
        label: { en: 'RACI Matrix', vi: 'Ma trận RACI' },
    },
    regulatory_frameworks: {
        route: '/admin/localization/frameworks',
        module: 'localization',
        label: { en: 'Regulatory Frameworks', vi: 'Khung tuân thủ' },
        location: { en: 'Regulatory › Frameworks', vi: 'Quy định › Quản lý khung tuân thủ' },
    },
    regulatory_updates: {
        route: '/admin/localization/regulatory-updates',
        module: 'localization',
        label: { en: 'Regulatory Updates', vi: 'Cập nhật Quy định' },
        location: { en: 'Regulatory › Frameworks', vi: 'Quy định › Quản lý khung tuân thủ' },
    },
    // ── Access and security ──
    access_log: {
        route: '/admin/access-accountability/access-log',
        module: 'access_accountability',
        label: { en: 'Access Log', vi: 'Nhật ký truy cập' },
    },
    access_reviews: {
        route: '/admin/access-reviews',
        module: null,
        label: { en: 'Access Reviews', vi: 'Xem xét truy cập' },
    },
    roles: {
        route: '/admin/roles',
        module: null,
        label: { en: 'Roles', vi: 'Vai trò' },
    },
    regulatory_artifacts: {
        route: '/admin/regulatory-artifacts',
        module: 'governance',
        label: { en: 'Artifact Catalog', vi: 'Danh mục tài liệu' },
    },
    restricted_access: {
        route: '/admin/regulatory-artifacts/grants',
        module: 'governance',
        label: { en: 'Restricted Access', vi: 'Quyền truy cập hạn chế' },
    },
    system_inventory: {
        route: '/admin/connectors/system-inventory',
        module: 'connectors',
        label: { en: 'System Inventory', vi: 'Kho hệ thống' },
    },
    // ── Payments and AML ──
    payment_services: {
        route: '/admin/payments-evidence/services',
        module: 'sector_overlays',
        label: { en: 'Payment Services', vi: 'Dịch vụ thanh toán' },
        location: {
            en: 'Sector Overlays › Banking & Payments',
            vi: 'Lớp phủ ngành › Ngân hàng và thanh toán',
        },
    },
    ekyc_evidence: {
        route: '/admin/payments-evidence/verifications',
        module: 'sector_overlays',
        label: { en: 'eKYC Evidence', vi: 'Bằng chứng eKYC' },
        location: {
            en: 'Sector Overlays › Banking & Payments',
            vi: 'Lớp phủ ngành › Ngân hàng và thanh toán',
        },
    },
    payments_retention: {
        route: '/admin/payments-evidence/retention',
        module: 'sector_overlays',
        label: { en: 'Retention Reconciliation', vi: 'Đối chiếu nghĩa vụ lưu trữ' },
        location: {
            en: 'Sector Overlays › Banking & Payments',
            vi: 'Lớp phủ ngành › Ngân hàng và thanh toán',
        },
    },
    supervisory_reporting: {
        route: '/admin/payments-evidence/supervisory-reporting',
        module: 'sector_overlays',
        label: { en: 'Supervisory Reporting', vi: 'Báo cáo giám sát' },
        location: {
            en: 'Sector Overlays › Banking & Payments',
            vi: 'Lớp phủ ngành › Ngân hàng và thanh toán',
        },
    },
    aml_programme: {
        route: '/admin/payments-evidence/aml-programme',
        module: 'sector_overlays',
        label: { en: 'AML Programme', vi: 'Chương trình phòng, chống rửa tiền' },
        location: { en: 'Sector Overlays › Crypto Assets', vi: 'Lớp phủ ngành › Tài sản mã hóa' },
    },
    suspicious_activity_cases: {
        route: '/admin/payments-evidence/aml-cases',
        module: 'sector_overlays',
        label: { en: 'Suspicious-Activity Cases', vi: 'Vụ việc giao dịch đáng ngờ' },
        location: { en: 'Sector Overlays › Crypto Assets', vi: 'Lớp phủ ngành › Tài sản mã hóa' },
    },
    controlled_testing_cases: {
        route: '/admin/controlled-testing/cases',
        module: 'localization',
        label: { en: 'Controlled-Testing Cases', vi: 'Hồ sơ thử nghiệm có kiểm soát' },
        location: { en: 'Regulatory › Regulatory Registers', vi: 'Quy định › Sổ đăng ký pháp lý' },
    },
    // ── Platform and trust evidence ──
    seller_register: {
        route: '/admin/platform-evidence/sellers',
        module: 'sector_overlays',
        label: { en: 'Seller Register', vi: 'Sổ đăng ký người bán' },
        location: { en: 'Sector Overlays › Digital Technology', vi: 'Lớp phủ ngành › Công nghệ số' },
    },
    transaction_reconciliation: {
        route: '/admin/platform-evidence/reconciliation',
        module: 'sector_overlays',
        label: { en: 'Transaction Reconciliation', vi: 'Đối soát giao dịch' },
        location: { en: 'Sector Overlays › Digital Technology', vi: 'Lớp phủ ngành › Công nghệ số' },
    },
    authority_correspondence: {
        route: '/admin/platform-evidence/authority-requests',
        module: 'sector_overlays',
        label: { en: 'Authority Correspondence', vi: 'Trao đổi với cơ quan có thẩm quyền' },
        location: { en: 'Sector Overlays › Digital Technology', vi: 'Lớp phủ ngành › Công nghệ số' },
    },
    trust_providers: {
        route: '/admin/trust-evidence/providers',
        module: 'governance',
        label: { en: 'Trust Providers', vi: 'Tổ chức cung cấp dịch vụ tin cậy' },
    },
    electronic_submissions: {
        route: '/admin/trust-evidence/submissions',
        module: 'governance',
        label: { en: 'Electronic Submissions', vi: 'Hồ sơ nộp điện tử' },
    },
    electronic_agreements: {
        route: '/admin/trust-evidence/agreements',
        module: 'governance',
        label: { en: 'Electronic Agreements', vi: 'Thỏa thuận điện tử' },
    },
    // ── Sector overlay registers ──
    sector_licences: {
        route: '/admin/sector-licences',
        module: 'localization',
        label: { en: 'Sector Licences', vi: 'Giấy phép ngành' },
        location: { en: 'Regulatory › Regulatory Registers', vi: 'Quy định › Sổ đăng ký pháp lý' },
    },
    // 2026-10-26 — P-VN-52: applications filed with their fee and charge lines.
    licence_applications: {
        route: '/admin/sector-licences/applications',
        module: 'sector_overlays',
        label: { en: 'Licence Applications and Fees', vi: 'Hồ sơ đề nghị cấp phép và phí, lệ phí' },
        location: { en: 'Sector Overlays › Digital Technology', vi: 'Lớp phủ ngành › Công nghệ số' },
    },
    regulated_accounts: {
        route: '/admin/regulated-accounts',
        module: 'sector_overlays',
        label: { en: 'Regulated Accounts', vi: 'Tài khoản chịu quản lý' },
        location: {
            en: 'Sector Overlays › Transport & Logistics',
            vi: 'Lớp phủ ngành › Giao thông vận tải và logistics',
        },
    },
    account_data_disclosures: {
        route: '/admin/account-data-disclosures',
        module: 'sector_overlays',
        label: { en: 'Account Data Disclosures', vi: 'Cung cấp dữ liệu tài khoản' },
        location: { en: 'Sector Overlays › Crypto Assets', vi: 'Lớp phủ ngành › Tài sản mã hóa' },
    },
    regulatory_disclosures: {
        route: '/admin/regulatory-disclosures',
        module: 'localization',
        label: { en: 'Regulatory Disclosures', vi: 'Công bố thông tin' },
        location: { en: 'Regulatory › Regulatory Registers', vi: 'Quy định › Sổ đăng ký pháp lý' },
    },
    marketing_approvals: {
        route: '/admin/marketing-approvals',
        module: 'localization',
        label: { en: 'Marketing Approvals', vi: 'Phê duyệt tiếp thị' },
        location: { en: 'Regulatory › Regulatory Registers', vi: 'Quy định › Sổ đăng ký pháp lý' },
    },
    investor_verifications: {
        route: '/admin/investor-verifications',
        module: 'sector_overlays',
        label: { en: 'Investor Verifications', vi: 'Xác minh nhà đầu tư' },
        location: { en: 'Sector Overlays › Crypto Assets', vi: 'Lớp phủ ngành › Tài sản mã hóa' },
    },
    product_classifications: {
        route: '/admin/product-classifications',
        module: 'localization',
        label: { en: 'Product Classifications', vi: 'Phân loại sản phẩm' },
        location: { en: 'Regulatory › Regulatory Registers', vi: 'Quy định › Sổ đăng ký pháp lý' },
    },
    conformity_certificates: {
        route: '/admin/conformity-certificates',
        module: 'localization',
        label: { en: 'Conformity Certificates', vi: 'Giấy chứng nhận hợp quy' },
        location: { en: 'Regulatory › Regulatory Registers', vi: 'Quy định › Sổ đăng ký pháp lý' },
    },
    student_records: {
        route: '/admin/student-records',
        module: 'sector_overlays',
        label: { en: 'Student Records', vi: 'Học bạ số' },
        location: { en: 'Sector Overlays › Education', vi: 'Lớp phủ ngành › Giáo dục' },
    },
    publications: {
        route: '/admin/publications',
        module: 'sector_overlays',
        label: { en: 'Publications', vi: 'Xuất bản phẩm' },
        location: { en: 'Sector Overlays › Publishing', vi: 'Lớp phủ ngành › Xuất bản' },
    },
    legal_representatives: {
        route: '/admin/legal-representatives',
        module: 'sector_overlays',
        label: { en: 'Legal Representatives', vi: 'Người đại diện theo pháp luật' },
        location: { en: 'Sector Overlays › Publishing', vi: 'Lớp phủ ngành › Xuất bản' },
    },
    publication_assessments: {
        route: '/admin/publication-assessments',
        module: 'sector_overlays',
        label: { en: 'Publication Assessments', vi: 'Đánh giá xuất bản phẩm' },
        location: { en: 'Sector Overlays › Publishing', vi: 'Lớp phủ ngành › Xuất bản' },
    },
    // Sprint 62.56.0 round 2 — the biometric capture-component register, a
    // primary destination of P-VN-50 and P-VN-51.
    biometric_capture_components: {
        route: '/admin/biometric-capture/components',
        module: 'sector_overlays',
        label: { en: 'Biometric Capture Components', vi: 'Thành phần thu nhận sinh trắc học' },
        location: {
            en: 'Sector Overlays › Public Administration',
            vi: 'Lớp phủ ngành › Hành chính công',
        },
    },
    // Sprint 62.56.0 round 2 (PU-4) — the supervision and inspection acts, a
    // primary destination of P-VN-51 (a focal unit or provincial police records
    // the guidance, monitoring and inspection acts it issues or receives).
    biometric_supervision_records: {
        route: '/admin/biometric-capture/supervision-records',
        module: 'sector_overlays',
        label: {
            en: 'Biometric Supervision and Inspection Records',
            vi: 'Hồ sơ hướng dẫn, theo dõi và kiểm tra về sinh trắc học',
        },
        location: {
            en: 'Sector Overlays › Public Administration',
            vi: 'Lớp phủ ngành › Hành chính công',
        },
    },
    // ── Manufacturing, food and logistics ──
    product_register: {
        route: '/admin/manufacturing/products',
        module: 'sector_overlays',
        label: { en: 'Product Register', vi: 'Sổ đăng ký sản phẩm' },
        location: { en: 'Sector Overlays › Manufacturing', vi: 'Lớp phủ ngành › Sản xuất' },
    },
    batch_serial_register: {
        route: '/admin/manufacturing/batches',
        module: 'sector_overlays',
        label: { en: 'Batch & Serial Register', vi: 'Sổ đăng ký lô và số sê-ri' },
        location: { en: 'Sector Overlays › Manufacturing', vi: 'Lớp phủ ngành › Sản xuất' },
    },
    trace_timeline: {
        route: '/admin/manufacturing/trace',
        module: 'sector_overlays',
        label: { en: 'Trace Timeline', vi: 'Dòng thời gian truy xuất' },
        location: { en: 'Sector Overlays › Manufacturing', vi: 'Lớp phủ ngành › Sản xuất' },
    },
    conformity_evidence: {
        route: '/admin/manufacturing/conformity',
        module: 'sector_overlays',
        label: { en: 'Conformity Evidence', vi: 'Bằng chứng hợp quy' },
        location: { en: 'Sector Overlays › Manufacturing', vi: 'Lớp phủ ngành › Sản xuất' },
    },
    capa_recall: {
        route: '/admin/manufacturing/capa-recall',
        module: 'sector_overlays',
        label: { en: 'CAPA & Recall', vi: 'Hành động khắc phục và thu hồi' },
        location: { en: 'Sector Overlays › Manufacturing', vi: 'Lớp phủ ngành › Sản xuất' },
    },
    epr_reconciliation: {
        route: '/admin/manufacturing/epr',
        module: 'sector_overlays',
        label: { en: 'EPR Reconciliation', vi: 'Đối chiếu EPR' },
        location: { en: 'Sector Overlays › Manufacturing', vi: 'Lớp phủ ngành › Sản xuất' },
    },
    chemical_register: {
        route: '/admin/manufacturing/chemicals',
        module: 'sector_overlays',
        label: { en: 'Chemical Register', vi: 'Sổ đăng ký hóa chất' },
        location: { en: 'Sector Overlays › Manufacturing', vi: 'Lớp phủ ngành › Sản xuất' },
    },
    ot_asset_profiles: {
        route: '/admin/manufacturing/ot-assets',
        module: 'sector_overlays',
        label: { en: 'OT Asset Profiles', vi: 'Hồ sơ tài sản OT' },
        location: { en: 'Sector Overlays › Manufacturing', vi: 'Lớp phủ ngành › Sản xuất' },
    },
    remote_access_assurance: {
        route: '/admin/manufacturing/remote-access',
        module: 'sector_overlays',
        label: { en: 'Remote Access Assurance', vi: 'Bảo đảm truy cập từ xa' },
        location: { en: 'Sector Overlays › Manufacturing', vi: 'Lớp phủ ngành › Sản xuất' },
    },
    shipment_register: {
        route: '/admin/logistics/shipments',
        module: 'sector_overlays',
        label: { en: 'Shipment Register', vi: 'Sổ đăng ký lô hàng' },
        location: {
            en: 'Sector Overlays › Transport & Logistics',
            vi: 'Lớp phủ ngành › Giao thông vận tải và logistics',
        },
    },
    customs_evidence: {
        route: '/admin/logistics/customs',
        module: 'sector_overlays',
        label: { en: 'Customs Evidence', vi: 'Bằng chứng hải quan' },
        location: {
            en: 'Sector Overlays › Transport & Logistics',
            vi: 'Lớp phủ ngành › Giao thông vận tải và logistics',
        },
    },
    inspections_holds: {
        route: '/admin/logistics/inspections',
        module: 'sector_overlays',
        label: { en: 'Inspections & Holds', vi: 'Kiểm tra và tạm giữ' },
        location: {
            en: 'Sector Overlays › Transport & Logistics',
            vi: 'Lớp phủ ngành › Giao thông vận tải và logistics',
        },
    },
    parcel_register: {
        route: '/admin/logistics/parcels',
        module: 'sector_overlays',
        label: { en: 'Parcel Register', vi: 'Sổ đăng ký bưu gửi' },
        location: {
            en: 'Sector Overlays › Transport & Logistics',
            vi: 'Lớp phủ ngành › Giao thông vận tải và logistics',
        },
    },
    delivery_evidence: {
        route: '/admin/logistics/delivery',
        module: 'sector_overlays',
        label: { en: 'Delivery Evidence', vi: 'Theo dõi và bằng chứng giao hàng' },
        location: {
            en: 'Sector Overlays › Transport & Logistics',
            vi: 'Lớp phủ ngành › Giao thông vận tải và logistics',
        },
    },
    logistics_claims: {
        route: '/admin/logistics/claims',
        module: 'sector_overlays',
        label: { en: 'Claims', vi: 'Khiếu nại' },
        location: {
            en: 'Sector Overlays › Transport & Logistics',
            vi: 'Lớp phủ ngành › Giao thông vận tải và logistics',
        },
    },
    postal_authorisations: {
        route: '/admin/logistics/authorisations',
        module: 'sector_overlays',
        label: { en: 'Postal Authorisations', vi: 'Giấy phép và thông báo hoạt động bưu chính' },
        location: {
            en: 'Sector Overlays › Transport & Logistics',
            vi: 'Lớp phủ ngành › Giao thông vận tải và logistics',
        },
    },
    // 2026-10-26 — P-VN-52 (Finance & Tax Accounting Lead): the customs tax
    // registers it works in. Labels are the sidebar's (AdminLayout, Sprint 62.55.0).
    customs_tax_payments: {
        route: '/admin/logistics/tax-payments',
        module: 'sector_overlays',
        label: { en: 'Tax Payments and Due Dates', vi: 'Nộp thuế và thời hạn nộp thuế' },
        location: {
            en: 'Sector Overlays › Transport & Logistics',
            vi: 'Lớp phủ ngành › Giao thông vận tải và logistics',
        },
    },
    customs_tax_dossiers: {
        route: '/admin/logistics/tax-dossiers',
        module: 'sector_overlays',
        label: {
            en: 'Tax Dossiers and Received Documents',
            vi: 'Hồ sơ thuế và văn bản nhận được từ cơ quan hải quan',
        },
        location: {
            en: 'Sector Overlays › Transport & Logistics',
            vi: 'Lớp phủ ngành › Giao thông vận tải và logistics',
        },
    },
    // ── Work, organisation and partner practice ──
    tasks: {
        route: '/admin/tasks',
        module: 'task_management',
        label: { en: 'All Tasks', vi: 'Tất cả tác vụ' },
    },
    training: {
        route: '/admin/training',
        module: 'assessments',
        label: { en: 'Training & Awareness', vi: 'Đào tạo và nhận thức' },
    },
    forms_dashboard: {
        route: '/admin/forms',
        module: 'compliance_forms',
        label: { en: 'Forms Dashboard', vi: 'Tổng quan biểu mẫu' },
    },
    form_catalog: {
        route: '/admin/forms/catalog',
        module: 'compliance_forms',
        label: { en: 'Form Catalog', vi: 'Danh mục biểu mẫu' },
    },
    organizations: {
        route: '/admin/organizations',
        module: 'organizations',
        label: { en: 'All Organizations', vi: 'Tất cả tổ chức' },
    },
    compliance_rollup: {
        route: '/admin/organizations/compliance-rollup',
        module: 'organizations',
        label: { en: 'Compliance Rollup', vi: 'Tổng hợp Tuân thủ' },
    },
    partner_orgs: {
        route: '/admin/partner-marketplace/partner-orgs',
        module: 'partner_workspace',
        label: { en: 'Partner Orgs', vi: 'Tổ chức đối tác' },
    },
    deliverables: {
        route: '/admin/partner-marketplace/deliverables',
        module: 'partner_workspace',
        label: { en: 'Deliverables', vi: 'Sản phẩm' },
    },
    support_tickets: {
        route: '/admin/partner-marketplace/support-tickets',
        module: 'partner_workspace',
        label: { en: 'Support Tickets', vi: 'Phiếu hỗ trợ' },
    },
    document_review: {
        route: '/admin/forseti/document-review',
        module: 'forseti',
        label: { en: 'Document Review', vi: 'Rà soát tài liệu' },
    },
};
/** Every destination key, in declaration order. */
export const PERSONA_DESTINATION_KEYS = Object.keys(PERSONA_DESTINATIONS);
/**
 * Sprint 63.35.0 (#561, decision 6) — the modules a persona's tours and help
 * articles follow: the modules of its destinations, in destination order, each
 * once. A persona is sent to registers, and its tours open those registers'
 * modules rather than the coarser `primary_modules` (P-VN-17's tours opened
 * Data Mapping and Classification while its destinations are manufacturing
 * registers). `primary_modules` is the fallback when no destination sits in a
 * module section. The caller filters by tier.
 */
export function personaTourModules(entry) {
    const out = [];
    for (const d of entry.primary_destinations) {
        const mod = typeof d === 'string'
            ? PERSONA_DESTINATIONS[d]?.module
            : d.module;
        if (mod && !out.includes(mod))
            out.push(mod);
    }
    return out.length > 0 ? out : [...entry.primary_modules];
}
//# sourceMappingURL=persona-destinations.js.map